import { Box, Drawer, makeStyles, Typography } from "@material-ui/core";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  drawer: {
    height: "60%",
    padding: "1.5rem",
    borderRadius: "10px 10px 0px 0px",
  },
  titleIcon: {
    transition: "transform 0.4s",
    whiteSpace: "nowrap",
    fontWeight: 420,
  },
  navLink: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.secondary,
    fontWeight: 400,
    textDecoration: "none",
    padding: "0.5rem 0rem 0.5rem 0.25rem",
    borderRadius: "10px",
    background: "transparent",
  },
  activeLink: {
    background: theme.palette.primary.main,
    color: "#FFFFFF",
    boxShadow: "0px 3px 6px #0000001F",
  },
}));

export default function TabMenu({ open, closeMenu, tabType }) {
  const cls = useStyles();

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={closeMenu}
      variant="temporary"
      classes={{
        paper: cls.drawer,
      }}
      ModalProps={{ onBackdropClick: closeMenu }}
      docked={false}
    >
      {tabType.map((element, index) => {
        return (
          <NavLink key={index} to={element["link"]} className={cls.navLink} activeClassName={cls.activeLink}>
            <Box py={0.5} display="flex" justifyContent="center" alignItems="center" onClick={closeMenu}>
              <Box mr={1}>{element["icon"]}</Box>
              <Typography variant="subtitle2">{element["name"]}</Typography>
            </Box>
          </NavLink>
        );
      })}
    </Drawer>
  );
}
